import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL;

if (!SOCKET_URL) {
  throw new Error('REACT_APP_API_URL is not set in the environment variables.');
}

const socket = io(SOCKET_URL, {
  transports: ['websocket'],
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
  autoConnect: false, // Connect manually when needed
});

socket.on('connect', () => {
  console.log('[socket] Admin panel connected to server:', socket.id);
});

socket.on('disconnect', (reason) => {
  console.log('[socket] Admin panel disconnected from server:', reason);
});

socket.on('connect_error', (err) => {
  console.error('[socket] Admin panel connection error:', err.message);
});

export default socket;
